import React, { useEffect, useState, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { useHistory } from "react-router";
import firebase from "firebase/app";
import { AuthContext } from "../context/AuthContext";
import getGigById from "../requests/getGigById";
import getTourById from "../requests/getTourById";
// import getProductsByTour from "../requests/getProductsByTour";
import getSalesByGig from "../requests/getSalesByGig";
import GigSalesDataTable from "./GigSalesDataTable";

const GigSalesData = () => {

  const { tourId, gigId } = useParams();
  const history = useHistory();

  const gigInitialState = [{
    date: "",
    venue: "",
    venueCut: 0
  }];
  
  const { user, setUser } = useContext(AuthContext);
  const [ token, setToken ] = useState("");
  // const [products, setProducts] = useState([]);
  const [gig, setGig] = useState(gigInitialState);
  // const [venue, setVenue] = useState("");
  // const [date, setDate] = useState("");
  const [sales, setSales] = useState([]);
  const [ tour, setTour ] = useState({
    name: "Tour details are loading...",
    gigs: [],
    products: [],
    editors: []
  });

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function(firebaseUser) {
      if (firebaseUser) {
        setUser(firebaseUser);
        firebaseUser.getIdToken().then(token => {
          setToken(token);
        })
      } else {
        history.push("/login");
      }
    });
  }, [history, setUser, user]);

  useEffect(() => {
    if (token) {
      getTourById(token, tourId).then(response => {
        // console.log(response);
        if (!response.data[0].gigs) {
          response.data[0].gigs = [];
        }
        if (!response.data[0].products) {
          response.data[0].products = [];
        }
        setTour(response.data[0]);
      })
    }
  }, [token, tourId]);

  useEffect(() => {
    if (token) {
      getGigById(token, tourId, gigId).then((response) => {
        setGig(response.data[0]);
        // setVenue(response.data[0].venue);
        // setDate(response.data[0].date);
      })
    }
  }, [gigId, token, tourId]);

  // useEffect(() => {
  //   if (token) {
  //     getProductsByTour(token, tourId).then((response) => {
  //       setProducts(response.data);
  //     })
  //   }
  // }, [tourId, token]);

  useEffect(() => {
    if (token) {
      getSalesByGig(token, gigId).then((response) => {
        setSales(response.data);
      })
    }
  }, [gigId, token]);

  // console.log("Venue", venue);
  // console.log("Date", date);
  // console.log("Products", products);
  // console.log("Sales", sales);

  const gigDate = new Date(gig.date).toDateString();
  if (!user) return (<></>);
  const userIsEditor = tour.editors.includes(user.uid);

  return (
    <div className="container">
      <Link className="nav-link" to={`/tour/${tourId}`}>Tour index page</Link>
      <h2 className="heading">Stock / sales input</h2>
      <h3><span className="gig-identifier">venue:</span> {gig.venue}</h3>
      <h3><span className="gig-identifier">date:</span> {gigDate}</h3>
      <section>
        <GigSalesDataTable
          tourId={tourId}
          gigId={gigId}
          sales={sales}
          userIsEditor={userIsEditor}
        />
      </section>
    </div>
  )

};

export default GigSalesData;